var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Seite nicht gefunden")]),_vm._v("\n\tZurück zur "),_c('router-link',{attrs:{"to":"/home"}},[_vm._v("Home")]),_vm._v("-Seite oder zum "),_c('router-link',{attrs:{"to":"/login"}},[_vm._v("Login")]),_vm._v(".\n  ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }